import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}><path d="M18 34C9.163 34 2 26.837 2 18S9.163 2 18 2s16 7.163 16 16a16 16 0 01-16 16zm0-30.5C9.992 3.5 3.5 9.992 3.5 18S9.992 32.5 18 32.5 32.5 26.008 32.5 18C32.491 9.996 26.004 3.509 18 3.5zM17.25 25h1.5V15h-1.5v10zm0-12.5h1.5V11h-1.5v1.5z" /></svg>);